









































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {swiper, swiperSlide} from 'vue-awesome-swiper';

@Component({
  components: {
    swiper,
    swiperSlide,
  },
})
export default class PartSix extends Vue {
  private isStarScale: number = 0;

  get swiperOption() {
    const that = this;
    return {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: false,
      effect: 'slide',
      on: {
        slideChangeTransitionEnd: () => {
          const swipers: any = this.$refs.swiperModel;
          const s = swipers.swiper;
          that.isStarScale = s.activeIndex;
        },
      },
    };
  }

  private swiperData: any = [
    {
      src: [require('@/assets/images/6-1-2.png')],
      title: ['打开 NIO App，', '在爱车频道点击一键加电'],
    },
    {
      src: [require('@/assets/images/6-2.png'), require('@/assets/images/6-2-1.png')],
      title: ['一键呼叫加电服务，', '详细地位帮助我们更快找到车辆'],
    },
    {
      src: [require('@/assets/images/6-3.png')],
      title: ['尽享休闲时光，', '服务进度在 NIO App 全程可见'],
    },
    {
      src: [require('@/assets/images/6-4.png')],
      title: ['服务完成，满电出发', '留言评价让我们做得更好'],
    },
  ];

}
